import React from "react";
import { Quote } from "lucide-react";

// Comparative observations computed only from real LONGVIEW scores already
// returned by /api/compare — never invented, and never phrased as advice.
const higherWins = (aVal, bVal, aLabel, bLabel, noun) => {
  if (aVal == null || bVal == null) return "Additional verified data is required to produce a meaningful comparison.";
  if (aVal === bVal) return `${aLabel} and ${bLabel} are evenly matched on ${noun}.`;
  const leader = aVal > bVal ? aLabel : bLabel;
  return `${leader} shows the stronger ${noun} (${Math.max(aVal, bVal)} vs ${Math.min(aVal, bVal)} / 100).`;
};

const lowerWins = (aVal, bVal, aLabel, bLabel, noun) => {
  if (aVal == null || bVal == null) return "Additional verified data is required to produce a meaningful comparison.";
  if (aVal === bVal) return `${aLabel} and ${bLabel} carry a similar ${noun}.`;
  const leader = aVal < bVal ? aLabel : bLabel;
  return `${leader} carries the lower ${noun} (${Math.min(aVal, bVal)} vs ${Math.max(aVal, bVal)} / 100).`;
};

export const VerdictPanel = ({ a, b, summary }) => {
  const rows = [
    { title: "Stronger Business Quality", text: higherWins(a.scores?.business_quality, b.scores?.business_quality, a.name, b.name, "business quality score") },
    { title: "Stronger Growth Profile", text: higherWins(a.scores?.growth, b.scores?.growth, a.name, b.name, "growth score") },
    { title: "Lower Risk Profile", text: lowerWins(a.scores?.risk, b.scores?.risk, a.name, b.name, "risk score") },
    {
      title: "Valuation Difference",
      text: a.scores?.valuation_label && b.scores?.valuation_label
        ? `${a.name} reads "${a.scores.valuation_label}" on valuation, while ${b.name} reads "${b.scores.valuation_label}".`
        : "Additional verified data is required to produce a meaningful comparison.",
    },
  ];

  return (
    <div data-testid="compare-summary" className="lv-panel lv-top-edge relative overflow-hidden p-6 sm:p-8">
      <Quote className="absolute right-6 top-6 h-10 w-10 text-amber-500/10" />
      <div className="kicker mb-1 text-amber-400">The LONGVIEW</div>
      <p className="mb-5 text-xs text-zinc-500">A structured view of how these businesses compare.</p>

      <div className="mb-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
        {rows.map((r) => (
          <div key={r.title} className="rounded-md border border-white/[0.07] bg-[#0B0C0E] p-3.5">
            <div className="kicker mb-1.5 text-zinc-400">{r.title}</div>
            <p className="text-xs leading-relaxed text-zinc-300">{r.text}</p>
          </div>
        ))}
      </div>

      <p className="max-w-3xl border-t border-white/[0.06] pt-5 font-serif text-lg leading-relaxed text-zinc-100">{summary}</p>
      <p className="mt-4 font-mono text-[10px] uppercase tracking-widest text-zinc-600">LONGVIEW synthesis · comparative intelligence, not investment advice</p>
    </div>
  );
};
